<template>
  <div class="mx-auto col-sm-12">
    <form id="activeForm" @submit.prevent>
      <h3>Ativo</h3>

      <div
        class="row p-2 mb-3"
        style="border: 1px solid #c7c6c6; border-radius: 5px"
      >
        <div class="form-group col-lg-12" :class="{ 'has-error': errors.has('serie') }">
          <label for="serie">{{ $t("serie") }}</label>
          <textarea
            type="text"
            id="serie"
            name="serie"
            class="form-control"
            :placeholder="$t('ph_serie')"
            v-model="active.serie"
            v-validate="'required'"
          />

          <small v-show="errors.has('serie')" class="form-text">
            {{ errors.first("serie") }}
          </small>
        </div>

        <div class="form-group col-lg-4">
          <label for="model">{{ $t("model") }}</label>
          <Combobox
            class="bg-white"
            name="model"
            :hasErrors="errors.has('model')"
            :placeholder="$t('select_a_item')"
            label="name"
            :options="models"
            :getOptionLabel="
              (model) =>
                model.name ? model.manufacturer.name + ' / ' + model.name : ''
            "
            :initial-value="active.model"
            v-model="active.model"
            :reduce="(models) => models.id"
            v-validate="'required'"
          />

          <small v-show="errors.has('model')" class="form-text">
            {{ errors.first("model") }}
          </small>
        </div>

        <div
          class="form-group col-lg-3"
          :class="{ 'has-error': errors.has('purchase_date') }"
        >
          <label for="purchase_date">{{ $t("purchase_date") }}</label>
          <input
            type="date"
            id="purchase_date"
            name="purchase_date"
            class="form-control"
            v-model="active.purchaseDate"
          />

          <small
            v-show="errors.has('purchase_date')"
            class="form-text text-muted"
          >
            {{ errors.first("purchase_date") }}
          </small>
        </div>

        <div
          class="form-group col-lg-2"
          :class="{ 'has-error': errors.has('purchase_value') }"
        >
          <label for="purchase_value"
            >{{ $t("purchase_value") }} (unitário)</label
          >
          <CurrencyInput
            v-model="active.purchaseValue"
            :auto-decimal-mode="true"
            :distraction-free="false"
            currency="BRL"
            locale="pt-BR"
            class="demo__currency-input form-control"
          />

          <small
            v-show="errors.has('purchase_value')"
            class="form-text text-muted"
          >
            {{ errors.first("purchase_value") }}
          </small>
        </div>

        <div
          class="form-group col-lg-3"
          :class="{ 'has-error': errors.has('warranty_date') }"
        >
          <label for="warranty_date">{{ $t("warranty_date") }}</label>
          <input
            type="date"
            id="warranty_date"
            name="warranty_date"
            class="form-control"
            v-model="active.warrantyDate"
          />
          <small
            v-show="errors.has('warranty_date')"
            class="form-text text-muted"
          >
            {{ errors.first("warranty_date") }}
          </small>
        </div>
      </div>

      <h3>Equipamento e Veículo</h3>

      <div
        class="row p-2 mb-3"
        style="border: 1px solid #c7c6c6; border-radius: 5px"
      >
        <div class="form-group col-lg-12">
          <label for="contract">{{ $t("contract") }}</label>
          <Combobox
            class="bg-white"
            name="contract"
            :placeholder="$t('select_a_item')"
            :hasErrors="errors.has('contract')"
            :options="contracts"
            :initial-value="equipmentAndVehicle.contract"
            label="contracts"
            v-model="equipmentAndVehicle.contract"
            :reduce="(contract) => contract.id_contrato"
            v-validate="'required'"
          />

          <small v-show="errors.has('contract')" class="form-text text-muted">
            {{ errors.first("contract") }}
          </small>
        </div>

        <div class="form-group col-lg-6">
          <label for="client">{{ $t("client") }}</label>
          <Combobox
            class="bg-white"
            name="client"
            :placeholder="$t('select_a_item')"
            :hasErrors="errors.has('client')"
            :options="clients"
            :initial-value="equipmentAndVehicle.client"
            label="nome_cliente"
            v-model="equipmentAndVehicle.client"
            :reduce="(client) => client.id"
            v-validate="'required'"
          />

          <small v-show="errors.has('client')" class="form-text text-muted">
            {{ errors.first("client") }}
          </small>
        </div>

        <div class="form-group col-lg-3">
          <label for="version">{{ $t("version") }}</label>
          <Combobox
            class="bg-white"
            name="version"
            :placeholder="$t('select_a_item')"
            :hasErrors="errors.has('version')"
            :options="equipmentVersions"
            :initial-value="equipmentAndVehicle.version"
            label="VER_DSC"
            v-model="equipmentAndVehicle.version"
            :reduce="(equipment) => equipment.id"
            v-validate="'required'"
          />

          <small v-show="errors.has('version')" class="form-text text-muted">
            {{ errors.first("version") }}
          </small>
        </div>

        <div class="form-group col-lg-3">
          <label for="vehicle_type">{{ $t("vehicle_type") }}</label>
          <Combobox
            class="bg-white"
            name="vehicle_type"
            :placeholder="$t('select_a_item')"
            label="TPV_DSC"
            :options="vehicleTypes"
            :reduce="(vehicleType) => vehicleType.TPV_ID"
            :initial-value="equipmentAndVehicle.vehicleType"
            v-model="equipmentAndVehicle.vehicleType"
            v-validate="'required'"
            :hasErrors="errors.has('vehicle_type')"
          />

          <small v-show="errors.has('vehicle_type')" class="form-text text-muted">
            {{ errors.first("vehicle_type") }}
          </small>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-4 col-sm-offset-2">
          <LoaderButton @click="onClick">
            {{ $t("save") }}
          </LoaderButton>
        </div>
      </div>
    </form>

    <!-- MODAL ERRORS -->
    <div class="modal fade" id="modalErrors" tabindex="-1" role="dialog" aria-labelledby="modalErrorsLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalErrorsLabel">Erros</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul v-for="error in addTrackersBatchErrors" :key="error.serie">
              <li>
                <strong>{{ error.serie }}</strong>: {{ error.error }}
              </li>
            </ul>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary block m-b mt-3 mr-2"
              data-dismiss="modal"
            >
              {{ $t('close') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LoaderButton from "@/components/button/LoaderButton";
import BootstrapTable from "bootstrap-table/dist/bootstrap-table-vue.esm.js";
import Combobox from "@/components/shared/ComboBox";

export default {
  name: "AddTrackersBatch",
  components: {
    LoaderButton,
    BootstrapTable,
    Combobox,
  },

  data() {
    return {
      active: {
        serie: "",
        model: undefined,
        purchaseDate: "",
        purchaseValue: 0,
        warrantyDate: "",
        activeType: 10,
        location: '',
        status: undefined
      },
      equipmentAndVehicle: {
        contract: undefined,
        client: undefined,
        version: undefined,
        vehicleType: undefined,
      }
    };
  },

  watch: {
    'equipmentAndVehicle.contract': function(value) {
      if (!value) {
        this.equipmentAndVehicle.client = undefined;

        return
      }

      const { id_cliente } = this.contracts.find(contract => contract.id_contrato == value);

      if (!id_cliente) {
        return
      }

      const client = this.clients.find(client => client.id == id_cliente);

      if (client) {
        this.equipmentAndVehicle.client = client.id;
      }
    }
  },

  computed: {
    ...mapState({
      models: (state) => state.model.all,
      clients: (state) => state.financial.clients,
      equipmentVersions: (state) => state.arena.equipmentVersions,
      contracts: (state) => state.contracts.all,
      vehicleTypes: (state) => state.vehicletypes.all,
      activestypes: state => state.activestype.all,
      addTrackersBatchErrors: state => state.active.addTrackersBatchErrors,
    }),
  },

  methods: {
    ...mapActions("active", ["create", "edit", "cleanState", "addTrackersBatch"]),

    async onClick(evtClick, doneFn) {
      const { dispatch } = this.$store
      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        const err = new Error(this.$t("invalid_form_fields"));
        dispatch("notify/error", err);
        return;
      }

      const allSerials = this.getSerials(this.active.serie)

      const obj = {
        ...this.active,
        ...this.equipmentAndVehicle,
        serie: allSerials
      }

      await this.addTrackersBatch(obj)

      this.addTrackersBatchErrors.length
        ? $('#modalErrors').modal('show')
        : dispatch('toast/showToast', {
            message: 'Equipamento(s) cadastrado(s) com sucesso!',
            type: 'success',
          });

      this.active = {
        serie: "",
        model: undefined,
        purchaseDate: "",
        purchaseValue: 0,
        warrantyDate: "",
        activeType: 10,
        location: '',
        status: undefined
      }

      this.equipmentAndVehicle = {
        contract: undefined,
        client: undefined,
        version: undefined,
        vehicleType: undefined,
      }
    },

    getSerials(text) {
      return text
        // Separa em cada vírgula ou quebra de linha (uma ou mais ocorrências)
        .split(/[\n,;]+/)
        // Remove espaços em branco antes e depois de cada item
        .map(item => item.trim())
        // Filtra entradas vazias (caso haja múltiplas vírgulas ou quebras juntas)
        .filter(item => item !== '')
        .join(';')
    }
  },

  async mounted() {
    const { dispatch } = this.$store;

    try {
      dispatch("overlay/show", true);

      await Promise.all([
        dispatch("financial/fetchClients"),
        dispatch("arena/fetchArenaEquipmentVersions"),
        dispatch("activestype/fetchAll"),
        dispatch("model/fetchFiltered", {
          activeType: 10,
          activeForm: true,
        }),
        dispatch("contracts/fetchAllContracts"),
        dispatch("vehicletypes/fetchAll", { excludeNoTracker: false }),
      ]);

      const { location, status } = this.activestypes.find(activeType => activeType.id === 10)

      if (location) {
        this.active.location = location
      }

      if (status) {
        this.active.status = status
      }

      this.equipmentAndVehicle.contract = 116
      this.equipmentAndVehicle.client = 1
    } catch (error) {
      console.log('[ERROR-FETCH-ALL-MOUNTED] => ', error)
    } finally {
      dispatch("overlay/show", false);
    }
  },
};
</script>
